/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCustomTransControl.ts            *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/custom-trans-control";

export class AutogenModelCustomTransControl<RowType extends ModelRow> extends Endpoint<RowType, RowCustomTransControlFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCustomTransControl extends ModelRow<RowCustomTransControlFields> {
	constructor(values?: Partial<RowCustomTransControlFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCustomTransControlFields {
	extension: string;
	node_name: string;
	prefix: string;
	sequence: number;
	trans_control_number: string;
	mask: string;
}

